import lazyloadHelper from "@ng-mw/shared-react-components/lazyloadHelper"

const { WithSuspense: InsightKeyFiguresInfo } = lazyloadHelper(
    () => import(/* webpackChunkName: "dietinsight" */ "./InsightKeyFiguresInfo"),
)

const { WithSuspense: DietInsight } = lazyloadHelper(
    () => import(/* webpackChunkName: "dietinsight" */ "./DietInsight"),
)

export { InsightKeyFiguresInfo, DietInsight }
export { DietPropertyInfo, DietEnergyInfo } from "@ng-mw/shared-react-components/diet"
